import { IFeaturesMap } from '../../../../../common/types/map';

interface IGetDisplayedFeaturesParams {
  /** Бакет текущего уровня детализации; undefined - ответ для этого уровня ещё не пришёл */
  currentFeatures: IFeaturesMap | undefined;
  /** Бакет последнего пришедшего уровня; undefined - бакетов нет (ошибка ответа сбрасывает все) */
  lastReadyFeatures: IFeaturesMap | undefined;
  /** Последний набор, показанный на карте */
  lastDisplayedFeatures: IFeaturesMap;
}

/**
 * Фичи, которые сейчас на карте: по ним пины и пересобираются, и перекрашиваются точечно.
 * При смене зума precision меняется раньше, чем приезжает ответ, а при зуме без запроса
 * (открыли список на десктопе) ответа нет вовсе. Пока бакета текущего уровня нет,
 * показываем последний пришедший: центры кластеров корректны на любом зуме, а живой бакет
 * из стора получает отметки просмотра и выбор. Честно пустой бакет снимает пины.
 */
export function getDisplayedFeatures({
  currentFeatures,
  lastReadyFeatures,
  lastDisplayedFeatures,
}: IGetDisplayedFeaturesParams): IFeaturesMap {
  return currentFeatures ?? lastReadyFeatures ?? lastDisplayedFeatures;
}
